import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation, inject, computed } from '@angular/core';
import { MatSliderModule } from '@angular/material/slider';
import { VideoPlayerService } from '../audio-player.service';
import { BackwardIconComponent } from '../icons/backward.component';
import { ForwardIconComponent } from '../icons/forward.component';
import { PlayIconComponent } from '../icons/play.component';
import { VolumeOnIconComponent } from '../icons/volume-on.component';
import { VolumeOffIconComponent } from '../icons/volume-off.component';
import { PauseIconComponent } from '../icons/pause.component';
import { ModalController } from '@ionic/angular';
import { MinimizeIconComponent } from '../icons/minimize.component';
import { NoCoverIconComponent } from '../icons/no-cover.component';

@Component({
  selector: 'audio-player',
  standalone: true,
  imports: [
    CommonModule,
    MatSliderModule,
    BackwardIconComponent,
    ForwardIconComponent,
    PlayIconComponent,
    VolumeOnIconComponent,
    VolumeOffIconComponent,
    PauseIconComponent,
    MinimizeIconComponent,
    NoCoverIconComponent
  ],
  templateUrl: './audio-modal.component.html',
  styleUrls: ['./audio-modal.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})

export class AudioModalComponent {
    private audioPlayerService = inject(VideoPlayerService);
    private modalController = inject(ModalController);
    
    public isPlaying = computed(() => this.audioPlayerService.isPlaying());
    public isMuted = computed(() => this.audioPlayerService.isMuted());
    public currentTime = computed(() => this.audioPlayerService.currentTime());
    public duration = computed(() => this.audioPlayerService.duration());
    public durationString = computed(() => this.audioPlayerService.durationString());
    public playingDurationString = computed(() => this.audioPlayerService.playingDurationString());

    handleBackward() {
        this.audioPlayerService.handleBackward();
    }

    handleForward() {
        this.audioPlayerService.handleForward();
    }

    handlePlayPause() {
        this.audioPlayerService.handlePlayPause();
    }

    toggleMute() {
        this.audioPlayerService.toggleMute();
    }

    changeValue(value: number){
        this.audioPlayerService.changeValue(value);
    }

    dismissModal(){
        this.modalController.dismiss().catch(e => {
            console.warn("No modal found on dismiss")
        });
    }

}